import type { PanelKind } from "./homeConfig";

/**
 * Deals the panels into independent columns, top to bottom, alternating.
 *
 * A row-based grid ties every card in a row to the tallest one, so a short panel beside a tall one
 * leaves the difference as dead space beneath it. Columns that stack on their own pack tightly
 * instead, and dealing alternately keeps each column's first card the one the authored order put
 * there — so the arrangement on screen is the same, minus the gaps.
 *
 * One column returns the panels untouched, which is what a narrow screen wants.
 */
export const splitIntoColumns = (panels: PanelKind[], columnCount: number): PanelKind[][] => {
  const columns: PanelKind[][] = Array.from({ length: Math.max(1, columnCount) }, () => []);
  panels.forEach((panel, index) => columns[index % columns.length].push(panel));
  return columns;
};
